import { useState, useEffect } from 'react';
import { string, bool } from 'prop-types';
import * as Styled from './Styled';
export const DatepickerPromo = ({
  caption,
  isMobile
}) => {
  const [isShown, setIsShown] = useState(false);
  useEffect(() => {
    setTimeout(() => setIsShown(true), 100);
  }, []);
  return /*#__PURE__*/React.createElement(Styled.DatepickerPromo, {
    isMobile: isMobile,
    isShown: isShown
  }, /*#__PURE__*/React.createElement("div", {
    className: "datepicker__promo"
  }, caption));
};
DatepickerPromo.propTypes = {
  caption: string,
  isMobile: bool
};